// extracted by mini-css-extract-plugin
var _1 = "Lx2zS";
var _2 = "hABVo";
export { _1 as "base", _2 as "label" }
